import React from 'react';
import { Redirect, RouteComponentProps, Switch } from 'react-router-dom';
import PruRoute from 'src/app/common/components/PruRoute';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import TaskSectionListPage, { todoListTaskSectionFilterKeys } from './List/TaskSectionListPage';
import EditTaskSectionPage from './View/components/EditTaskSection';

const TodoListTaskSectionPage = ({ match }: RouteComponentProps) => {
  return (
    <Switch>
      <Redirect exact from={match.path} to={`${match.path}/list`} />
      <PruRoute
        exact
        path={`${match.path}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={todoListTaskSectionFilterKeys}>
            <TaskSectionListPage />
          </ParamsProvider>
        )}
      />
      <PruRoute exact path={`${match.path}/edit/:id/:id`} component={EditTaskSectionPage} />
    </Switch>
  );
};

export default TodoListTaskSectionPage;
